import ContentsCustomTypes from "@project/enums/contentsCustomTypes.enum";
import ContentsTypes from "@shared/enums/contentsTypes";
export const GradientButton = {
    label: "Bouton avec effet",
    icon: "hand-pointer",
    type: ContentsCustomTypes.GRADIENT_BUTTON,
    editionModal: true,
    editionModalPosition: "top",
    children: [
        {
            label: "Contenu du bouton",
            key: "text",
            type: ContentsTypes.INPUT,
            value: "Texte",
        },
        {
            label: "Contenu du bouton en mobile",
            key: "mobileText",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Couleur",
            key: "color",
            type: ContentsTypes.BUTTON_GROUP,
            width: "50%",
            options: [
                { label: "Primaire", value: "primary" },
                { label: "Secondaire", value: "secondary" },
            ],
            value: "primary",
        },
        {
            label: "Style",
            key: "variant",
            type: ContentsTypes.BUTTON_GROUP,
            width: "50%",
            options: [
                {
                    label: "Plein",
                    value: "contained",
                    title: "Boutons d'actions principales (contained)",
                },
                {
                    label: "Contour",
                    value: "outlined",
                    title: "Boutons d'actions secondaires (outlined)",
                },
                {
                    label: "Texte",
                    value: "text",
                    title: "Boutons d'actions secondaires (texte)",
                },
                {
                    label: "Icône",
                    value: "icon",
                    title: "Boutons d'actions secondaires (icon)",
                },
            ],
            value: "contained",
        },
        {
            label: "Taille du bouton",
            key: "size",
            type: ContentsTypes.BUTTON_GROUP,
            width: "50%",
            options: [
                { label: "Petit", value: "small" },
                { label: "Moyen", value: "medium" },
                { label: "Grand", value: "large" },
            ],
            value: "medium",
        },
        {
            label: "Prendre toute la largeur",
            key: "fullWidth",
            type: ContentsTypes.CHECKBOX,
            width: "50%",
            value: "false",
        },
        {
            key: "justifyContent",
            label: "Alignement",
            type: ContentsTypes.BUTTON_GROUP,
            options: [
                { label: "À gauche", icon: "align-left", value: "flex-start" },
                { label: "Centré", icon: "align-center", value: "center" },
                { label: "À droite", icon: "align-right", value: "flex-end" },
            ],
            value: "flex-start",
        },
        {
            label: "Lien du bouton",
            key: "link",
            type: ContentsTypes.LINK,
            value: "",
        },
        {
            label: "Icone",
            key: "icon",
            type: ContentsTypes.ICON,
            value: "",
        },
    ],
};
